import { useQuery } from '@tanstack/react-query';
import { useServices } from 'index';

export const useGetUserInvoices = () => {
  const invoicesService = useServices().invoicesService;
  return useQuery({
    queryKey: ['userInvoices'],
    queryFn: () => invoicesService.getInvoices(),
    refetchOnWindowFocus: false
  });
};
